var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 0.666504H2.99992C1.53325 0.666504 0.333252 1.8665 0.333252 3.33317V24.6665C0.333252 26.1332 1.53325 27.3332 2.99992 27.3332H18.9999C20.4666 27.3332 21.6666 26.1332 21.6666 24.6665V8.6665L13.6666 0.666504ZM10.9999 11.3332C12.4666 11.3332 13.6666 12.5332 13.6666 13.9998C13.6666 15.4665 12.4666 16.6665 10.9999 16.6665C9.53325 16.6665 8.33325 15.4665 8.33325 13.9998C8.33325 12.5332 9.53325 11.3332 10.9999 11.3332ZM16.3333 21.9998H5.66658V21.2398C5.66658 20.1598 6.30659 19.1998 7.29325 18.7732C8.42659 18.2798 9.67992 17.9998 10.9999 17.9998C12.3199 17.9998 13.5733 18.2798 14.7066 18.7732C15.6933 19.1998 16.3333 20.1598 16.3333 21.2398V21.9998Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdPerson);
export default __webpack_public_path__ + "static/media/idPerson.0d7c82a4151c56e664642eb0bdfbd671.svg";
export { ForwardRef as ReactComponent };